/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Check_TestsInputs */

const en_rd_check_tests = /** @type {(inputs: Rd_Check_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test runner configured`)
};

const id_rd_check_tests = /** @type {(inputs: Rd_Check_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test runner sudah disetel`)
};

/**
* | output |
* | --- |
* | "Test runner configured" |
*
* @param {Rd_Check_TestsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_check_tests = /** @type {((inputs?: Rd_Check_TestsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Check_TestsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_check_tests(inputs)
	return en_rd_check_tests(inputs)
});